import {Flow, FlowStatus} from '../../WorkFlow/FlowTypes'
import {PortalMenuItem} from '../types'
import {MENU_ICONS, ROUTES} from '../constants'

interface BuildMenuItemsParams {
  portalFlow: Flow
  isAdmin: boolean
  duplicatingId: string | null
  FlowStatus: typeof FlowStatus
  t: (key: string) => string
  onViewActivity: (id: string) => void
  onEdit: (id: string, isAdmin: boolean) => void
  onSettings: (flow: Flow) => void
  onDuplicate: (id: string) => void
  onToggleStatus: (id: string, status: FlowStatus) => void
  onResume: (id: string, name: string) => void
  onDelete: (id: string) => void
}

export const buildMenuItems = ({
  portalFlow,
  isAdmin,
  duplicatingId,
  FlowStatus,
  t,
  onViewActivity,
  onEdit,
  onSettings,
  onDuplicate,
  onToggleStatus,
  onResume,
  onDelete,
}: BuildMenuItemsParams): PortalMenuItem[] => {
  const items: PortalMenuItem[] = [
    {
      iconClass: MENU_ICONS.VIEW_ACTIVITY,
      label: 'View Activity',
      onClick: () => {
        if (!isAdmin) {
          onViewActivity(portalFlow._id)
        }
      },
    },
    {
      iconClass: MENU_ICONS.EDIT,
      label: 'Edit',
      onClick: () => onEdit(portalFlow._id, isAdmin),
    },
    {
      iconClass: MENU_ICONS.SETTINGS,
      label: 'Settings',
      onClick: () => onSettings(portalFlow),
    },
    {
      iconClass: MENU_ICONS.DUPLICATE,
      label: 'Duplicate',
      onClick: () => onDuplicate(portalFlow._id),
      loading: duplicatingId === portalFlow._id,
      disabled: duplicatingId === portalFlow._id || !!duplicatingId,
    },
    {
      iconClass:
        portalFlow.status === FlowStatus.ACTIVE ? MENU_ICONS.PAUSE : MENU_ICONS.PLAY,
      label: portalFlow.status === FlowStatus.ACTIVE ? 'Pause' : 'Play',
      onClick: () => {
        const newStatus =
          portalFlow.status === FlowStatus.ACTIVE ? FlowStatus.INACTIVE : FlowStatus.ACTIVE
        onToggleStatus(portalFlow._id, newStatus)
      },
    },
  ]

  if (portalFlow.haveJobPaused) {
    items.push({
      iconClass: MENU_ICONS.RESUME,
      label: 'Resume Flow',
      onClick: () => onResume(portalFlow._id, portalFlow.name),
    })
  }

  items.push({
    iconClass: MENU_ICONS.DELETE,
    label: t('DELETE'),
    onClick: () => onDelete(portalFlow._id),
    danger: true,
  })

  return items
}

